import {Component, OnInit, ViewChild} from '@angular/core';
import {DataOperationService} from '../utils/data-services/data-operation.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatTableDataSource} from '@angular/material/table';
import {DataConcessionService} from '../utils/data-services/dataConcession.service';
import swal from 'sweetalert2';
import {MatPaginator} from '@angular/material/paginator';
import {PngoDealershipService} from '../utils/data-services/pngo-dealership.service';
import {SelectionModel} from "@angular/cdk/collections";

@Component({
  selector: 'app-gestion-operation',
  templateUrl: './gestion-operation.component.html',
  styleUrls: ['./gestion-operation.component.scss']
})
export class GestionOperationComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dealershipId: any;
  dataSource = new MatTableDataSource();
  originalDataSource = [];
  concessionName: any;
  constructor(
    private pngoDealershipService: PngoDealershipService,
    private dataService: DataOperationService,
    private activeRoute: ActivatedRoute,
    private route: Router,
    private dataServiceConcession: DataConcessionService
  ) { }
  displayedColumns: string[] = ['checkbox', 'bmw_id', 'sofNet_id', 'nom', 'minimum_delay', 'requiredStandartRangeService', 'dynamicTest', 'vt', 'actif', 'ordre', 'blocked', 'commentaireAdditionnel', 'aideAdditionnel', 'type', 'attente_autorise', 'modifier'];
  search: any;
  active: boolean[] = [true, false];
  blocked: boolean[] = [true, false];
  waitingAuthorization: boolean[] = [true, false];
  softnetInfo: any;
  operationsToUpdate = [];

  // false = sélection multiple (multi), true = sélection unique
  selection = new SelectionModel<Element>(true, []);


  ngOnInit() {
    this.dealershipId = Number(this.activeRoute.snapshot.paramMap.get('idConcession'));
    this.getOperation();
    this.getConcessionById();
    this.active = JSON.parse(localStorage.getItem('filterOperationActive'));
    this.blocked = JSON.parse(localStorage.getItem('filterOperationBlocked'));
    this.waitingAuthorization = JSON.parse(localStorage.getItem('filterOperationWaitingAuthorization'));
    this.search = localStorage.getItem('operationFilter') != null ? localStorage.getItem('operationFilter') : '';
    this.dataSource.filter = this.search.trim().toLowerCase();
    this.paginator.pageIndex = localStorage.getItem('pageIndexOperation') != null ? parseInt(localStorage.getItem('pageIndexOperation')) : null;
    this.paginator.pageSize = localStorage.getItem('pageSizeOperation') != null ? parseInt(localStorage.getItem('pageSizeOperation')) : null;
    this.dataSource.paginator = this.paginator;
    this.getSoftNetInfos(this.dealershipId);
  }
  filterOperations() {
    localStorage.setItem('filterOperationActive', JSON.stringify(this.active));
    localStorage.setItem('filterOperationBlocked', JSON.stringify(this.blocked));
    localStorage.setItem('filterOperationWaitingAuthorization', JSON.stringify(this.waitingAuthorization));
    this.dataSource.data = this.originalDataSource;
    if (this.active.length > 0 && this.blocked.length === 0 && this.waitingAuthorization.length === 0) {
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.active.includes(e.actif));
    } else if (this.blocked.length > 0 && this.active.length === 0 && this.waitingAuthorization.length === 0) {
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.blocked.includes(e.blocked));
    } else if (this.waitingAuthorization.length > 0 && this.active.length === 0 && this.blocked.length === 0) {
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.waitingAuthorization.includes(e.attente_autorise));
    } else if (this.active.length > 0 && this.blocked.length > 0 && this.waitingAuthorization.length === 0) {
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.active.includes(e.actif));
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.blocked.includes(e.blocked));
    } else if (this.active.length === 0 && this.blocked.length > 0 && this.waitingAuthorization.length > 0) {
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.active.includes(e.actif));
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.blocked.includes(e.blocked));
    } else if (this.active.length > 0 && this.blocked.length === 0 && this.waitingAuthorization.length > 0) {
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.active.includes(e.actif));
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.waitingAuthorization.includes(e.attente_autorise));
    } else if (this.active.length > 0 && this.blocked.length > 0 && this.waitingAuthorization.length > 0) {
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.active.includes(e.actif));
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.blocked.includes(e.blocked));
      this.dataSource.data = this.dataSource.data.filter((e: any) => this.waitingAuthorization.includes(e.attente_autorise));
    } else {
      this.dataSource.data = this.originalDataSource;
    }
  }
  getOperation() {
    this.dataService.getOperationByConcession(this.dealershipId).subscribe(result => {
      for (const operation of result) {
        operation.checked = false;
      }
      this.search = localStorage.getItem('operationFilter') != null ? localStorage.getItem('operationFilter') : '';
      this.dataSource.filter = this.search.trim().toLowerCase();
      this.dataSource.data = result;
      this.originalDataSource = result;
      this.filterOperations();
    });
  }
  getConcessionById() {
    this.dataServiceConcession.getConcessionById(this.dealershipId).subscribe(result => {
      this.concessionName = result.nom_concession;
    });
  }
  SelectChangeHandlerCreer() {
    this.route.navigate(['../creation-operation/' + this.dealershipId]);
  }
  SelectChangeHandlerModifier(idOperation) {
    this.route.navigate(['../modification-operation/' + idOperation]);
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    localStorage.setItem('operationFilter', filterValue);
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  onClickMessage(message) {
    swal.fire({
      title: 'Message',
      text: message,
      confirmButtonText: 'Ok'
    });
  }
  getPageSizeOptions(): number[] {
    if (this.dataSource && this.dataSource.data.length > 100 && this.dataSource.paginator) {
      return [20, 50, 100,  this.dataSource.paginator.length];
    } else {
      return [20, 50, 100];
    }
  }
  displayPaginatorAllOption() {
    const matOptions = document.getElementsByClassName('mat-option-text');
    // @ts-ignore
    for (const options of matOptions) {
      options.innerHTML = options.innerHTML == this.dataSource.data.length ? 'Tous' : options.innerHTML;
    }
  }
  pageChange() {
    localStorage.setItem('pageIndexOperation', String(this.paginator.pageIndex));
    localStorage.setItem('pageSizeOperation', String(this.paginator.pageSize));
  }
  getSoftNetInfos(dealershipId) {
    this.pngoDealershipService.getSoftNetInformations(dealershipId).subscribe(result => {
      this.softnetInfo = result;
    });
  }
  getDayOfTheWeek(day: number): string {
    const days = [
      'Dimanche',
      'Lundi',
      'Mardi',
      'Mercredi',
      'Jeudi',
      'Vendredi',
      'Samedi'
    ];
    return days[day];
  }

  /** Toutes les lignes sont-elles cochées ? */
  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows     = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Coche tout ou décoche tout */
  masterToggle(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      const stored = localStorage.getItem('operationFilter');
      const filter = stored ? stored.trim().toLowerCase() : '';

      this.dataSource.data
        .filter((row: any) =>
          !filter ||
          [row.bmw_id, row.sofNet_id, row.nom, row.type]
            .some(value =>
              value !== null && value !== undefined &&
              String(value).toLowerCase().includes(filter)
            )
        )
        .forEach(row => this.selection.select(<Element>row));
    }
  }

  /** Label d'accessibilité pour la checkbox */
  checkboxLabel(row?: Element): string {
    if (!row) {
      return `${this.isAllSelected() ? 'Désélectionner' : 'Sélectionner'} tout`;
    }
    return `${this.selection.isSelected(row) ? 'Désélectionner' : 'Sélectionner'} ligne ${row.id}`;
  }
  massUpdate() {
    localStorage.setItem('operationSelection', JSON.stringify(this.selection.selected));
    this.route.navigate(['../modification-multiple-operation']);
  }
}
